import React from "react";

import TodayIcon from "@mui/icons-material/Today";

import { MobileDatePicker as MuiMobileDatePicker } from "@mui/lab";

import { ButtonBase } from "@mui/material";

import { DatePickerHook } from "commons/hooks/input/useDatePicker";
import useDateFormat from "commons/hooks/useDateFormat";

import DateTimePickerToolbar from "commons/ui/DateTimePickerToolbar";
import InputText from "commons/ui/input/InputText";

type PropsType = {
    datePickerHook: DatePickerHook;
};

function MobileDatePicker({ datePickerHook }: PropsType) {
    const {
        isOpen,
        errors,
        dateString,
        onOpen,
        onClose,
        onTodayIconClick,
        onInputTextChange,
        onDatePickerChange,
        onFocus,
        onBlur,
        value,
        label,
        minDate,
        maxDate,
        disabled,
        tabIndex,
        filterInput,
        required,
        toolbarTitle,
        inputTextExtraClassName,
        startAdornment,
        autoFocus,
    } = datePickerHook;

    const onChangeIgnore = React.useCallback(() => {}, []);

    const { formatDate, getPlaceholderDate } = useDateFormat();

    const renderInput = React.useCallback(
        ({ inputRef }) => (
            <InputText
                ref={inputRef}
                label={label}
                className={`date-time-picker ${inputTextExtraClassName}`}
                value={value ? formatDate(value) : dateString}
                onChange={onInputTextChange}
                onFocus={onFocus}
                onBlur={onBlur}
                placeholder={getPlaceholderDate()}
                tabIndex={tabIndex}
                disabled={disabled}
                errors={errors}
                filterInput={filterInput}
                required={required}
                startAdornment={
                    startAdornment !== undefined ? (
                        <ButtonBase onClick={onTodayIconClick} title={"Apri calendario"}>
                            {startAdornment}
                        </ButtonBase>
                    ) : undefined
                }
                endAdornment={
                    startAdornment ? undefined : (
                        <div
                            className={`end-adornment ${disabled ? "disabled" : ""}`}
                            onClick={onTodayIconClick}
                        >
                            <TodayIcon titleAccess={"Apri calendario"} />
                        </div>
                    )
                }
                autoFocus={autoFocus}
            />
        ),
        [
            onTodayIconClick,
            onInputTextChange,
            onFocus,
            onBlur,
            getPlaceholderDate,
            formatDate,
            dateString,
            errors,
            value,
            filterInput,
            tabIndex,
            disabled,
            required,
            label,
            inputTextExtraClassName,
            startAdornment,
            autoFocus,
        ]
    );

    return (
        <MuiMobileDatePicker
            clearable
            clearText={"Cancella"}
            cancelText={"Annulla"}
            toolbarTitle={toolbarTitle ?? "Seleziona data"}
            leftArrowButtonText={"Mese precedente"}
            rightArrowButtonText={"Mese successivo"}
            orientation={"portrait"}
            open={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            onAccept={onDatePickerChange}
            value={value}
            minDate={minDate}
            maxDate={maxDate}
            renderInput={renderInput}
            onChange={onChangeIgnore}
            ToolbarComponent={DateTimePickerToolbar}
        />
    );
}

export default MobileDatePicker;
